<template>
<div>
	<ul class="top-menu text-white">
		<!--<li class="large-only">
			<router-link to="/find">
				<i class="fa fa-search"></i>
				<div>People</div>
			</router-link>
		</li>-->
		<li :class="{'clocked-in': $store.clockedIn == 'onsite','clocked-in-offsite':$store.clockedIn == 'offsite'}" v-if='hasActiveEmployer() && isOnActiveEmployer() && !$store.companySetupMode'>
			<a href="#" v-on:click.prevent="goToPunchClock">
				<div v-if="$store.clockedIn" class="elapsed-time">{{ timeElapsed }}</div>
				<div v-if="$store.clockedIn == 'onsite'">Clock Out</div>
				<div v-else-if="$store.clockedIn == 'offsite'">Offsite</div>
				<template v-else>
					<i class="fa fa-clock"></i>
					<div>Clock In</div>
				</template>
			</a>
			<onboarding-tip v-if="$store.onboardingTips.clockIn"
				message="Clock into your first job here!" 
				style="left: -125px;"
				v-on:close="$store.onboardingTips.clockIn = false;$store.onboardingTips.logExpense = true">
			</onboarding-tip>
		</li>
		<li v-if='hasActiveEmployer() && isOnActiveEmployer() && !$store.companySetupMode' class="more-on-condensed">
			<router-link to="/expenses/log">
				<i class="fa fa-receipt"></i>
				<div>+ Expense</div>
			</router-link>
			<onboarding-tip v-if="$store.onboardingTips.logExpense"
				message="Log expenses here" 
				style="left: 5px;"
				v-on:close="$store.onboardingTips.logExpense = false;$store.onboardingTips.messages = true">
			</onboarding-tip>
		</li>
		<li v-if="!$store.companySetupMode" class="more-on-condensed">
			<router-link :to="'/employee/'+$store.userSlug+'/profile'">
				<i class="fa fa-user-circle"></i>
				<div>Profile</div>
			</router-link>
		</li>
		<li v-if="!$store.companySetupMode" style="position: relative;">
			
			<a href="#" v-on:click.prevent="messagesClick">
				<i class="fa fa-envelope" style="font-size: 16px"></i>
				<div>Messages</div>
				<i v-if="$store.unreadMessageThreads.length > 0" class="fa fa-comment message-notice"></i>
			</a>

			<sub-menu 
				v-if="messagesMenuVisible"
				v-on:closeMenu="messagesMenuVisible = false"
				v-on:linkClick="messagesMenuVisible = false"
				:items="mutatedThreads"
				:heading="messagesSubMenuHeading">

				<a v-if="!messagePanelOpen && aboveBreakpoint && $route.name != 'Messages' && $route.name != 'ThreadOpen'" href="#" class="btn btn-link" v-on:click.prevent="openPanel" style="border-top: 1px solid #e0e0e0">
					<i class="fa fa-envelope"></i>
					See All Messages
				</a>

				<router-link v-else-if="!messagePanelOpen && !aboveBreakpoint && $route.name != 'Messages' && $route.name != 'ThreadOpen'" to="/messages" class="btn btn-link" v-on:click.native="messagesMenuVisible = false">See All Messages</router-link>

				<a href="#" class="btn btn-link" v-on:click.prevent="newThread" style="border-top: 1px solid #e0e0e0">
					<i class="fa fa-plus"></i>
					New Thread
				</a>
			</sub-menu>
		
		</li>
		<li v-if="!$store.companySetupMode" style="position: relative;">
			
			<a href="#" v-on:click.prevent="notificationMenuVisible = true">
				<i class="fa fa-bell" style="font-size: 16px"></i>
				<div>Alerts</div>
				<i v-if="newNotifications.length > 0" class="fa fa-exclamation message-notice"></i>
			</a>

			<sub-menu 
				v-if="notificationMenuVisible"
				v-on:closeMenu="notificationMenuVisible = false"
				v-on:linkClick="notificationMenuVisible = false"
				:items="reviewItems"
				:heading="reviewItems.length > 0 ? 'Review Items' : false">

				<div>
					<h4 class="heading">Alerts</h4>
					<ul class="notifications-list">
						<li v-for="note in $store.recentNotifications" class="notification" :class="{'recent-notification':moment.utc(note.created_at).local().isAfter(moment().subtract(1,'days'))}">
							<component :is="note.link.search('http') >= 0 || note.link.search('https://tradetraks.app') >= 0 ? 'a' : 'router-link'" :to="note.link ? note.link : '/notifications/feed'" :href="note.link ? note.link : '/notifications/feed'">
								{{note.message}}
							</component>
						</li>
					</ul>
				</div>

				<router-link to="/notifications/feed" class="btn btn-link" v-on:click.native="notificationMenuVisible = false">Alert Center</router-link>
			</sub-menu>
		
		</li>
		<li v-if="getUserRoleType() == 'Admin'" :class="{'more-on-condensed':!$store.companySetupMode}" v-on:click="supportChat">
			
			<i class="fa fa-question-circle"></i>
			<div>Support</div>
			
		</li>
		<li v-if="!$store.companySetupMode" class="more-menu">
			<a href="#" v-on:click.prevent="moreMenuVisible = true">
				<i class="fa fa-ellipsis-h" style="font-size: 16px"></i>
				<div>More</div>
			</a>

			<sub-menu 
				v-if="moreMenuVisible"
				v-on:closeMenu="moreMenuVisible = false"
				v-on:itemClick="moreClick"
				v-on:linkClick="moreMenuVisible = false"
				:items="filteredMoreItems"
				heading="More">
			</sub-menu>
		</li>
		<li v-on:click="logout" :class="{'more-on-condensed':!$store.companySetupMode}">
			<i class="fa fa-sign-out-alt"></i>
			<div>Log Out</div>
		</li>
	</ul>
	<onboarding-tip v-if="$store.onboardingTips.messages"
		message="Message your friends here" 
		style="right: 95px;"
		v-on:close="$store.onboardingTips.messages = false">
	</onboarding-tip>
</div>
</template>

<script type="text/javascript">
import SubMenu from "@/layout_fragments/SubMenu"
import OnboardingTip from "@/components/OnboardingTip"

export default {
	name: 'TopMenu',
	components: {
		SubMenu,
		OnboardingTip
	},
	props: ["messagePanelOpen","mobileBreakpoint"],
	data() {
		return {
			messagesMenuVisible: false,
			notificationMenuVisible: false,
			moreMenuVisible: false,
			timer: null,
			timeElapsed: "",
			moreItems: [
				{
					link: '/employee/'+this.$store.userSlug+'/profile',
					text: 'View Profile',
					icon: 'fa-user-circle'
				},
				{
					link: '/expenses/log',
					text: '+ Log an Expense',
					icon: 'fa-receipt'
				},
				{
					text: 'Get Support',
					icon: 'fa-question-circle'
				},
				{
					text: 'Log Out',
					icon: 'fa-sign-out-alt'
				}
			]
		}
	}, 
	watch: {
		'$store.clockinTime'() {
			if (this.$store.clockinTime) 
				this.startClockedInTimer()
			else
				clearInterval(this.timer)
		}
	},
	computed: {
		aboveBreakpoint() {
			return window.innerWidth > this.mobileBreakpoint
		},
		filteredMoreItems() {
			let moreItems = JSON.parse(JSON.stringify(this.moreItems))

			if (!this.hasActiveEmployer()) {
				moreItems = moreItems.filter(item => {
					if (item.link == '/expenses/log')
						return false
					else
						return true
				})
			}

			return moreItems
		},
		messagesSubMenuHeading() {
			if (this.$store.unreadMessageThreads.length > 0)
				return "Unread Messages"
			else
				return false
		},
		//undismissed notifications
		newNotifications() {
			return this.$store.recentNotifications.filter(noti => noti.is_dismissed == 0)
		},
		reviewItems() {
			let vm = this

			let reviewItems = []

			if (this.$store.numTimeLogsToReview > 0)
				reviewItems.push({text: this.$store.numTimeLogsToReview+' Time Logs',icon:'fa-clock',link:'/time-logs/review'})

			if (this.$store.numExpensesToReview > 0)
				reviewItems.push({text: this.$store.numExpensesToReview+' Expenses',icon:'fa-receipt',link: '/expenses/review'})

			if (this.$store.lastReleaseNoteDate && this.moment(this.$store.lastReleaseNoteDate).isSame(this.moment(),'day')) {
				let day = this.moment.utc(this.$store.lastReleaseNoteDate).local().format("MMM D, YYYY")

				reviewItems.push({text: this.$store.appName+" News: "+day,icon:'fa-bullhorn',link:'/notifications/news'})
			}

			return reviewItems
		},
		mutatedThreads() {
			let vm = this

			if (this.$store.unreadMessageThreads.length > 0) {

				return this.$store.unreadMessageThreads.map(thread => {

					if ("Service" in thread && thread.Service) 
						thread.subject = thread.Service.job_num+": "+thread.subject
					
					else if ("Job" in thread && thread.Job) 
						thread.subject = thread.Job.job_num+": "+thread.subject
					
					thread.text = thread.subject
					thread.link = "/message/"+thread.slug

					return thread
				})
			}
			else {
				return [{
					text: "No unread messages"
				}]
			}
		}
	},
	methods: {
		clockInTimeElapsed() {
			let vm = this

			let localTimeIn = this.moment.utc(this.$store.clockinTime).local()

			let duration = this.moment.duration(this.moment().diff(localTimeIn))

			let min = duration.minutes()

			if (min < 10)
				min = "0"+min

			let hrs = duration.hours()

			let sec = duration.seconds()

			if (sec < 0)
				return "Out of Sync"
			if (sec < 10)
				sec = "0"+sec

			if (isNaN(hrs) || isNaN(min) || isNaN(sec)) { //prevent ugly NaN:NaN:NaN flash
				return "Out of Sync"
			}

			return hrs+":"+min+":"+sec
		},
		startClockedInTimer() {
			let vm = this
			this.timer = setInterval(() => {
				vm.timeElapsed = vm.clockInTimeElapsed()
			},1000)
		},
		messagesClick() {

			if (window.innerWidth < this.mobileBreakpoint)
				this.messagesMenuVisible = true
			else if (this.$route.path != "/messages") 
				this.openPanel()
			
		},
		moreClick(item) {
			if (item.text == "Get Support")
				this.supportChat()
			else if (item.text == 'Log Out')
				this.$emit("logout")

			this.moreMenuVisible = false
		},
		logout() {
			this.$emit("logout")
		},
		closeMessagesSubMenu() {
			this.messagesMenuVisible = false
		},
		refreshMessages() {
			this.$bus.$emit("reloadMessages")
		},
		supportChat() {
			let vm = this

			this.$bus.$emit("newSupportThread") 
		},
		newThread() {
			this.messagesMenuVisible = false
			this.$bus.$emit("newThread")
		},
		openPanel() {
			this.messagesMenuVisible = false
			this.$emit("openMessagePanel")
 		},
 		goToPunchClock() {
 			console.log("punch-clock")
 			this.getLocation()
 			this.$router.push("/punch-clock")
 		}
	},
	created() {
		let vm = this
		vm.timeElapsed = vm.clockInTimeElapsed()

		if (this.$store.clockinTime) 
			this.startClockedInTimer()

		this.$bus.$on("newMessages",() => {
			vm.$forceUpdate()
		})
	},
	destroyed() {
		clearInterval(this.timer)
	}
}

</script>

<style type="text/css" scoped>

.top-menu {
	list-style: none;
	padding: 0;
	position: absolute;
	right: 0;
	top: 0;
	color: var(--text-dark);
	display: flex;
	flex-direction: row;
	margin: 0;
}

.top-menu a, .top-menu button {
	text-decoration: none;
	color: inherit;
	display: block;
}

.top-menu li {
	display: inline-block;
	padding: 1px;
	padding-left: 10px;
	padding-right: 10px;
	text-align: center;
	vertical-align: top;
	cursor: pointer;
}

.top-menu li .fa {
	color: var(--brand-primary-color-faded);
}

.top-menu li .message-notice {
	color: red;
}

.top-menu li.icon-only {
	padding-top: 5px;
	font-size: 16pt;
}

.top-menu li.clocked-in {
	background-color: red;
	color: white;
}

.top-menu li.clocked-in-offsite {
	background-color: orange;
}

.top-menu .elapsed-time {
	font-size: 12pt;
	font-weight: bold;
}

.top-menu li:hover, .top-menu li:hover .fa {
	background-color: #788e98;
	color: white;
}

.top-menu li:hover {
	background-color: #788e98;
}

.notifications-list {
	border-bottom: 1px solid #e0e0e0;
}

.notifications-list li {
	text-align: left;
}

.notifications-list li:hover {
	background-color: #e2ecf1;
	color: #455A64;
}

/*.top-menu li ul {
	position: absolute;
	right: 0;
	padding: 0;
	margin: 0;
	background-color: #455A64;
	color: white;
	width: 236px;
}*/

.top-menu li ul {
	padding: 0;
	margin: 0;
}

.top-menu li ul li {
	display: block;
	padding: 5px;
	border-top: 1px solid #e0e0e0;
}

.top-menu div {font-size: 10pt;}

.message-notice {
	color: red;
	position: absolute;
	top: 0px;
	right: 10px;
}

.top-menu li.more-menu {
	display: none;
}

@media (max-width: 750px) {
	.top-menu .large-only {
		display: none;
	}

	.top-menu li {
		padding-left: 5px;
		padding-right: 5px;
	}
}

@media (max-width: 450px) {
	.top-menu li.more-menu {
		display: block;
	}

	.top-menu li.more-on-condensed {
		display: none;
	}
}

</style>
